// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function AddpanelLayout(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'AddpanelLayout',
      'aria-hidden': true,
      focusable: false,
      width: 39 * scale,
      height: 35 * scale,
      viewBox: '0 0 39 35',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fill: 'currentColor',
      fillOpacity: '.2',
      stroke: 'currentColor',
      d: 'M.5 19.5h10v15H.5zm0-19h38v15H.5zm14 19h24v15h-24z',
    })
  );
}
